<template>
  <div class="d-flex flex-column align-items-center px-3 py-2">
    <router-link :to="`/addEnconter`" class="text-decoration-none" >
      <button  class="add-topic-btn mt-3">New Encounter</button>
    </router-link>
    <router-link :to="`/patients`" class="text-decoration-none" >
      <button  class="add-topic-btn my-3">My Patients</button>
    </router-link>
    <input v-model="searchQuery" type="text" class="form-control mb-3" placeholder="Search Topics" @input="search"/> 
    <ul v-if="(isSearching ? searchTopics.length > 0 : topics.length > 0)" class="list-group" style="width:100%">
      <li v-for="topic in  (isSearching ? searchTopics : topics)" :key="topic.id" class="card d-flex flex-row justify-content-between align-items-center px-3 my-1">
        <a  class="d-flex flex-row " @click="() => {storePatientId(topic.patient_id);topic.is_draft ? goToDraft(topic.id,topic.name) : goToDetails(topic.id,topic.name);}">
          <div class="mt-2">
            <i v-if="topic.is_draft" class="fa fa-pen-to-square " aria-hidden="true"></i>
            <i v-else class="fa-solid fa-file-lines fs-4 text-primary " aria-hidden="true"></i>
          </div>
          <div class="text-start ms-3">
            <p class="mb-0" > <span style="color:#518DB1;">{{ topic.name }}</span></p>
            <p class="mb-0" > PID: {{ topic.patient_id }}  <small class="fw-light" style="font-size: 11px;"><i class="fa-solid fa-clock fw-light" ></i> {{ topic.duration }} min</small></p>
            <small class="fw-light" style="font-size: 11px;"><i class="fa-solid fa-calendar fw-light" ></i> {{ new Date(topic.created_at).toLocaleString() }}</small>
          </div>
        </a>
        <div class="dropdown">
          <button class="btn btn-white " @click="toggleDropdown(topic.id)">
            <i class="fa fa-ellipsis-v"></i>
          </button>
          <ul v-if="topic.showDropdown" class="dropdown-menu">
            <li><a class="dropdown-item"  @click="handleSend(topic, 'pdf')">Send as PDF</a></li>
            <li><a class="dropdown-item"  @click="handleSend(topic, 'docx')">Send as DOCX</a></li>
          </ul>
        </div>
      </li>
    </ul>
    <p v-else-if="isSearching && searchTopics.length === 0">No results found.</p>
    <p v-else>No topics available.</p>
    <ul class="pagination pt-3">
      <li class="page-item" :class="{ disabled: currentPage === 1 }">
        <a class="page-link" href="#" @click.prevent="handlePageClick(currentPage - 1)" aria-label="Previous">
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>

      <li v-for="page in pages" :key="page" class="page-item" :class="{ active: page === currentPage }">
        <a class="page-link" href="#" @click.prevent="handlePageClick(page)">{{ page }}</a>
      </li>

      <li class="page-item" :class="{ disabled: currentPage === totalPages }">
        <a class="page-link" href="#" @click.prevent="handlePageClick(currentPage + 1)" aria-label="Next">
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>

import { ref, onMounted ,watch,computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter} from 'vue-router'; 
import { useToast } from 'vue-toastification';
import { getTopicListService, searchEncountersService } from '@/services/api/encounterService';
import { sendReportEmailService } from '@/services/api/commonService';

const store = useStore();
const currentView = computed(() => store.state.navigationData?.view || '');
const router = useRouter();
const topics = ref([]);
const searchTopics = ref([]);
const currentPage = ref(1);
const totalPages = ref(1);
const toast = useToast();
const token = localStorage.getItem('token');
const searchQuery = ref(''); 
const isSearching = ref(false);
const refreshFlag = computed(() => store.state.navigation.refreshTopicsFlag)

watch(refreshFlag, () => {
  getTopics(currentPage.value, 2) 
})
const storePatientId = (patientId) => {
  store.commit('setPatientId', patientId);
};

const getTopics = async (page, dialogId) => {
  try {
    const response = await getTopicListService(page, dialogId);
    topics.value = response.responseData.chats.map(chat => ({
      ...chat,
      selectedOption: '', 
      showDropdown: false 
    }));
    currentPage.value = response.data.responseData.page;
    totalPages.value = response.data.responseData.total_pages;
  } catch (err) {
    if (err.response?.status === 401) {
      await getTopics(token, page, dialogId); 
    }
  }
};

const search = async () => {
  if (!searchQuery.value) {
    isSearching.value = false;
    await getTopics(currentPage.value, 2);
    return;
  }

  const response = await searchEncountersService(searchQuery.value);
  const chats = response.chats;
  if (!chats || chats ===  "No Chats") {
        searchTopics.value = [];
        isSearching.value = true;
  } else {
    searchTopics.value = chats.map(chat => ({
      ...chat,
      selectedOption: '',
      showDropdown: false,
    }));
    isSearching.value = true;
    currentPage.value = response.page;
    totalPages.value = response.total_pages;
  }
};
const handlePageClick = (pageNum) => {
  if (pageNum !== currentPage.value) {
    getTopics(pageNum, 2); 
  }
};
watch(searchQuery, (newQuery) => {
  if (newQuery.length === 0) {
    isSearching.value = false;
    getTopics(currentPage.value,2);
  }
});

const pages = computed(() => {
  const arr = [];
  if (totalPages.value <= 3) {
    for (let i = 1; i <= totalPages.value; i++) {
      arr.push(i);
    }
  } else {
    if (currentPage.value > 2) arr.push(1, '...');
    for (let i = Math.max(1, currentPage.value - 1); i <= Math.min(totalPages.value, currentPage.value + 1); i++) {
      arr.push(i);
    }
    if (currentPage.value < totalPages.value - 1) arr.push('...', totalPages.value);
  }
  return arr;
});

watch(
  currentView,
      async (newView, oldView) => {
        if (newView === oldView) return; 
        await getTopics(currentPage.value, 2); 
      }
    );

onMounted(() => { 
  getTopics(currentPage.value, 2);  
});
const goToDetails = (topicId) => {
  const data = {  view: 'details' };
  store.commit('setTopicId', topicId);
  store.dispatch('navigation/saveNavigationData', data);
  router.push({ name: 'encounter' }); 
};
const goToDraft = (topicId,patientNameV) => {
  const data = { topicId, patientNameV ,view: 'record' } ;
  store.dispatch('navigation/saveNavigationData', data);
  router.push({ name: 'encounter'});
};
const getSendPdf = async (chatId, type) => {
  try {
    const result = await sendReportEmailService(chatId, type);
    toast.success("Mail Sent successfully");
    return result;
  } catch (e) {
    console.error("Failed to send report email:", e);
    toast.error("Something went wrong");
  }
};

const handleSend = async (topic, type) => {
  await getSendPdf(topic.id, type);
  topic.showDropdown = false; 
};

const toggleDropdown = (topicId) => {
  topics.value.forEach(topic => {
    if (topic.id === topicId) {
      topic.showDropdown = !topic.showDropdown;
    } else {
      topic.showDropdown = false;
    }
  });
};
</script>

<style scoped>
.topics-container {
  padding: 20px;
  max-width: 600px;
  margin: auto;
  background-color: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

h1 {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}

ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.topic-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  margin-bottom: 10px;
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
}

.topic-item:hover {
  background-color: #f0f0f0;
}

.topic-link {
  display: flex;
  align-items: center;
  flex-grow: 1;
  text-decoration: none;
  color: #333;
}

.draft-icon,
.encounter-icon {
  margin-right: 10px;
  font-size: 1.2rem;
  color: #518DB1;
}

.topic-name {
  flex-grow: 1;
  font-weight: 500;
}

.share-btn {
  background: none;
  border: none;
  color: #518DB1;
  cursor: pointer;
  font-size: 1.2rem;
  padding: 5px;
}

.share-btn:focus {
  outline: none;
}
.add-topic-btn {
  background-color: #518DB1;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.add-topic-btn:hover {
  background-color: #518DB1;
}

.dots-btn {
  background: none;
  border: none;
  color: #518DB1;
  cursor: pointer;
  font-size: 1.2rem;
  padding: 5px;
}

.dots-btn:focus {
  outline: none;
}

.dropdown-menu {
  display: flex;
  flex-direction: column;
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  right:0;
}

.dropdown-menu a {
  padding: 10px;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
a{
  text-decoration: none;
  cursor: pointer;
  color: #333;
}

.dropdown-menu a:hover {
  background-color: #f0f0f0;
}
.page-link.active , .active > .page-link {
  background-color: #518db1 !important;
  border-color:#518db1 !important;
}

@media (max-width: 480px) {
  .topic-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .topic-name {
    margin-bottom: 10px;
  }

  .share-btn {
    align-self: flex-end;
  }
}
</style>